import { cn } from '@/lib/utils'

export const phoneVerificationStatuses = [
  'pending',
  'verifying',
  'verified',
  'failed',
] as const

export type PhoneVerificationStatus = (typeof phoneVerificationStatuses)[number]

const statusColorMap: Record<PhoneVerificationStatus, string> = {
  pending: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  verifying: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  verified: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  failed: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
}

export function phoneVerificationStatusClasses(
  status: PhoneVerificationStatus,
) {
  return cn(
    'inline-flex rounded-full px-2 text-xs font-semibold leading-5',
    statusColorMap[status],
  )
}
